var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 1257.249343832021 866.5826771653543",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l1257.2494 0l0 866.5827l-1257.2494 0l0 -866.5827z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l1257.2494 0l0 866.5827l-1257.2494 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p.1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(44.42542289115162 0.0 0.0 44.42542289115162 0.0 0.0)",
    spreadMethod: "pad",
    x1: -2.0111751750720375,
    y1: 9.767233255402354,
    x2: 29.414847970478814,
    y2: 41.16824069645366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0984e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0984e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5500001,
    stopColor: "#74b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#74b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71000004,
    stopColor: "#81ecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ecec"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p.1)",
    d: "m1042.6318 942.54645l-356.9626 -413.2287l106.06836 -386.7281l-80.570435 -479.48972l468.12885 481.41882l-88.732056 66.26097l428.35425 0l-85.66846 -67.467255l468.1289 -485.03296l-81.591675 488.4077l107.0896 379.97858l-360.0221 414.435l289.13892 -664.5436l-129.01526 96.86392l-420.19666 834.8921l-421.21387 -832.4842l-129.52783 -101.07886z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p.2",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-35.59560368923422 31.060652813155755 31.060652813155755 35.59560368923422 0.0 0.0)",
    spreadMethod: "pad",
    x1: -36.38274915878988,
    y1: 39.87703936721767,
    x2: -0.787145469555667,
    y2: 39.87703936721767
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#101010",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p.2)",
    d: "m1528.728 -862.1837l-1266.9922 1105.5748l1004.9448 1151.559l1266.9922 -1105.5747z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.8b811da4a23ae54057fba9a88a3fc1c2.svg";
export { ForwardRef as ReactComponent };